import Vuex from 'vuex';
import Vue from 'vue';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    name: 'JAND',
    useCache: true,
    mode: 'reader',
    site: null,
    user: null,
    seasons: null,
    strips: null,
    latestStrip: null,
    lastRead: null,
    discounts: null,
    characters: null,
    payments: null,
    currencies: ['NGN', 'GBP'],
  },
  getters,
  actions,
  mutations,
});

store.subscribe((mutation, state) => {
  localStorage.setItem('store', JSON.stringify(state));
});

export default store;
